import PropTypes from 'prop-types';
import ClassDateItem from './ClassDateItem';

const defaultProps = {
  dates: [],
};

const propTypes = {
  dates: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      time: PropTypes.string,
    })
  ),
};

export default function ClassDates({ dates }) {
  return (
    <div className="flex flex-col p-4 rounded">
      <div className="flex flex-col space-y-1">
        {dates.map(({ date, time }) => (
          <div key={date} className="flex items-center">
            <ClassDateItem date={date} time={time} />
          </div>
        ))}
      </div>
    </div>
  );
}

ClassDates.defaultProps = defaultProps;
ClassDates.propTypes = propTypes;
